import Vue from 'vue'
import Vuex from 'vuex'
import weeklyTalesService from '../api/weeklyTales.js'

Vue.use(Vuex)

const initialState = {
  personStories: [],
  allStories: []
}

const getters = {
  personStories(state) {
    return state.personStories
  },
  allStories(state) {
    return state.allStories
  },
}

export const actions = {
  async getDeceasedStories(context, payload) {
    try {
      const response = await weeklyTalesService.getDeceasedStories(payload);
      context.state.personStories = response.data
      return Promise.resolve();
    } catch (error) {
      const errorMessage = context.rootState.langObj.response.error[error.response.data] || context.rootState.langObj.response.error.somethingWentWrong;
      context.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true });
      return Promise.reject(error);
    }
  },
  async getAllDeceasedStories(context, payload) {
    try {
      const response = await weeklyTalesService.getAllDeceasedStories(payload);
      context.state.allStories = response.data
      return Promise.resolve();
    } catch (error) {
      const errorMessage = context.rootState.langObj.response.error[error.response.data] || context.rootState.langObj.response.error.somethingWentWrong;
      context.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true });
      return Promise.reject(error);
    }
  },
  async deleteDeceasedStory(context, payload) {
    try {
      const response = await weeklyTalesService.deleteDeceasedStory(payload);
      context.commit('toast', { message: context.rootState.langObj.response.success.deleteStory, color: 'black' }, { root: true })
      return Promise.resolve();
    } catch (error) {
      const errorMessage = context.rootState.langObj.response.error[error.response.data] || context.rootState.langObj.response.error.somethingWentWrong;
      context.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true });
      return Promise.reject(error);
    }
  }
}

export const state = { ...initialState }

export default {
  namespaced: true,
  state,
  getters,
  actions
}
